import { render, staticRenderFns } from "./createTable.vue?vue&type=template&id=fdf2fd6c"
import script from "./createTable.vue?vue&type=script&lang=js"
export * from "./createTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports